const contact = (type) => {
  if (type === 'email') return 'Field does not contain a valid email address.';
  return 'This field has invalid characters.';
};

export default contact;
